(() => {
  if (window.SmoofPictogramLibrary) return;

  const scriptUrl = document.currentScript?.src || '';
  const assetUrl = fileName => {
    try { return new URL(fileName, scriptUrl || window.location.href).href; }
    catch (error) { return fileName; }
  };

  /* Existing IDs stay unchanged so old .smoofdesign files remain compatible. */
  const icons = [
    { id: 'dots', category: 'arrows', de: 'SMOOF Punkte-Pfeil', en: 'SMOOF dot arrow', standard: true, repeatable: true, aspect: 1.7606 },
    { id: 'chevron-in', category: 'arrows', de: 'Chevron nach innen', en: 'Chevron inward', sideAware: true, body: '<path d="M28 18 62 50 28 82"/><path d="M49 18 83 50 49 82"/>' },
    { id: 'arrow-in', category: 'arrows', de: 'Pfeil nach innen', en: 'Arrow inward', sideAware: true, body: '<path d="M15 50h66"/><path d="m57 25 25 25-25 25"/>' },
    { id: 'arrow-down', category: 'arrows', de: 'Pfeil nach unten', en: 'Arrow down', body: '<path d="M50 14v68"/><path d="m25 58 25 25 25-25"/>' },
    { id: 'arrow-up', category: 'arrows', de: 'Pfeil nach oben', en: 'Arrow up', body: '<path d="M50 86V18"/><path d="m25 42 25-25 25 25"/>' },
    { id: 'curved-arrow', category: 'arrows', de: 'Gebogener Pfeil', en: 'Curved arrow', sideAware: true, body: '<path d="M18 76c4-32 21-48 57-48"/><path d="M57 12 78 28 60 48"/>' },

    { id: 'smoof-arrow-left', category: 'arrows', de: 'Handpfeil links – Scan', en: 'Hand arrow left – Scan', asset: 'smoof-pictogram-arrow-left.svg', aspect: 87.22 / 34.94 },
    { id: 'smoof-arrow-right', category: 'arrows', de: 'Handpfeil rechts – Discover', en: 'Hand arrow right – Discover', asset: 'smoof-pictogram-arrow-right.svg', aspect: 95.35 / 43.04 },
    { id: 'smoof-nfc-arrow-left', category: 'arrows', de: 'Handpfeil links – Tap or Scan', en: 'Hand arrow left – Tap or Scan', asset: 'smoof-pictogram-nfc-arrow-left.svg', aspect: 87.22 / 34.89 },
    { id: 'smoof-fork-left', category: 'arrows', de: 'Gabel links – Food', en: 'Fork left – Food', asset: 'smoof-pictogram-fork-left.svg', aspect: 91.61 / 32.75 },
    { id: 'smoof-knife-right', category: 'arrows', de: 'Messer rechts – Drinks', en: 'Knife right – Drinks', asset: 'smoof-pictogram-knife-right.svg', aspect: 89.22 / 37.73 },

    { id: 'smartphone', category: 'digital', de: 'Smartphone', en: 'Smartphone', body: '<rect x="27" y="10" width="46" height="80" rx="8"/><path d="M43 20h14"/><circle cx="50" cy="78" r="2" fill="white" stroke="none"/>' },
    { id: 'tap-phone', category: 'digital', de: 'Smartphone antippen', en: 'Tap smartphone', body: '<rect x="20" y="12" width="42" height="75" rx="7"/><path d="M34 22h14"/><path d="M70 30c9 5 14 13 14 23M69 43c4 3 6 7 6 12"/>' },
    { id: 'contactless', category: 'payment', de: 'Kontaktlos', en: 'Contactless', body: '<path d="M26 68c11-10 11-26 0-36M42 78c18-17 18-39 0-56M58 87c25-24 25-50 0-74"/><circle cx="18" cy="50" r="3" fill="white" stroke="none"/>' },
    { id: 'credit-card', category: 'payment', de: 'Kreditkarte', en: 'Credit card', body: '<rect x="10" y="23" width="80" height="54" rx="8"/><path d="M10 39h80"/><path d="M22 61h20"/>' },
    { id: 'wallet', category: 'payment', de: 'Wallet', en: 'Wallet', body: '<path d="M16 26h64a8 8 0 0 1 8 8v43H20a9 9 0 0 1-9-9V31a9 9 0 0 1 9-9h53"/><path d="M64 44h24v20H64a10 10 0 0 1 0-20Z"/><circle cx="70" cy="54" r="2" fill="white" stroke="none"/>' },
    { id: 'terminal', category: 'payment', de: 'Kartenterminal', en: 'Payment terminal', body: '<rect x="24" y="8" width="52" height="84" rx="9"/><rect x="34" y="19" width="32" height="20" rx="3"/><path d="M36 53h2m12 0h2m12 0h2M36 65h2m12 0h2m12 0h2M36 77h2m12 0h2m12 0h2"/>' },
    { id: 'qr-scan', category: 'digital', de: 'QR-Code scannen', en: 'Scan QR code', body: '<path d="M12 35V15h20M68 15h20v20M88 65v20H68M32 85H12V65"/><rect x="29" y="30" width="16" height="16"/><rect x="56" y="30" width="15" height="15"/><rect x="29" y="57" width="15" height="15"/><path d="M57 58h6v6h8v9H59v-6"/>' },
    { id: 'receipt', category: 'order', de: 'Beleg', en: 'Receipt', body: '<path d="M25 10h50v80l-8-6-8 6-9-6-9 6-8-6-8 6Z"/><path d="M36 31h28M36 45h28M36 59h18"/>' },
    { id: 'order-bag', category: 'order', de: 'Bestellung / Abholung', en: 'Order / pickup', body: '<path d="M20 33h60l-5 55H25Z"/><path d="M36 36V26a14 14 0 0 1 28 0v10"/><path d="M40 57h20"/>' },
    { id: 'cloche', category: 'food', de: 'Servierglocke', en: 'Serving cloche', body: '<path d="M13 70h74M22 68a28 28 0 0 1 56 0M45 33a5 5 0 0 1 10 0"/><path d="M9 78h82"/>' },
    { id: 'fork-knife', category: 'food', de: 'Besteck', en: 'Cutlery', body: '<path d="M25 10v31M16 10v19c0 8 5 12 9 12s9-4 9-12V10M25 41v49M63 10v80M63 10c17 12 21 30 0 43"/>' },
    { id: 'menu', category: 'food', de: 'Speisekarte', en: 'Menu', body: '<path d="M14 17h31a9 9 0 0 1 9 9v61H23a9 9 0 0 1-9-9ZM86 17H55a9 9 0 0 0-9 9v61h31a9 9 0 0 0 9-9Z"/><path d="M25 37h14M25 50h14M61 37h14M61 50h14"/>' },
    { id: 'wine-glass', category: 'food', de: 'Weinglas', en: 'Wine glass', body: '<path d="M31 10h38l-4 27c-2 13-7 20-15 20s-13-7-15-20Z"/><path d="M35 31h30M50 57v25M35 88h30"/>' },
    { id: 'cocktail-glass', category: 'food', de: 'Cocktailglas', en: 'Cocktail glass', body: '<path d="M16 15h68L50 53Z"/><path d="M50 53v29M32 88h36"/><path d="m60 27 15-14"/><circle cx="64" cy="24" r="5"/>' },
    { id: 'champagne-glass', category: 'food', de: 'Sektglas', en: 'Champagne glass', body: '<path d="M35 10h30l-4 31c-1 10-5 16-11 16s-10-6-11-16Z"/><path d="M50 57v25M36 88h28"/><circle cx="45" cy="35" r="2"/><circle cx="53" cy="27" r="2"/>' },
    { id: 'service-bell', category: 'hospitality', de: 'Service', en: 'Service bell', body: '<path d="M14 72h72M21 69a29 29 0 0 1 58 0M46 32a4 4 0 0 1 8 0"/><path d="M10 80h80"/>' },
    { id: 'room-key', category: 'hospitality', de: 'Zimmer / Schlüssel', en: 'Room / key', body: '<circle cx="34" cy="38" r="20"/><path d="m49 53 36 36M68 72l10-10M77 81l10-10"/>' },
    { id: 'wifi', category: 'hospitality', de: 'WLAN', en: 'Wi-Fi', body: '<path d="M13 37a55 55 0 0 1 74 0M25 52a38 38 0 0 1 50 0M38 67a18 18 0 0 1 24 0"/><circle cx="50" cy="81" r="4" fill="white" stroke="none"/>' },

    { id: 'underline-swoosh', category: 'underlines', de: 'Underline – Schwung', en: 'Underline – Swoosh', aspect: 3.8, viewBox: [0, 0, 380, 100], body: '<path d="M14 76C91 27 203 76 291 39c29-12 54-24 75-34" stroke-width="22"/>' },
    { id: 'underline-double', category: 'underlines', de: 'Underline – Doppelt', en: 'Underline – Double', aspect: 4.1, viewBox: [0, 0, 410, 100], body: '<path d="M12 34c91 35 244 22 386-14" stroke-width="18"/><path d="M35 78c112 23 253 7 347-22" stroke-width="12"/>' },
    { id: 'underline-brush', category: 'underlines', de: 'Underline – Pinsel', en: 'Underline – Brush', aspect: 4.2, viewBox: [0, 0, 420, 100], body: '<path d="M8 48c82-34 206-43 329-24l75 18-72 31C218 94 105 91 8 72Z" fill="white" stroke="none"/>' },
    { id: 'underline-wave', category: 'underlines', de: 'Underline – Welle', en: 'Underline – Wave', aspect: 4, viewBox: [0, 0, 400, 100], body: '<path d="M10 57c47-65 93 58 141-7s96 54 150-8 73 21 89-3" stroke-width="18"/>' },
    { id: 'underline-sketch', category: 'underlines', de: 'Underline – Skizze', en: 'Underline – Sketch', aspect: 4.3, viewBox: [0, 0, 430, 100], body: '<path d="M9 36c107-24 259-19 412-35M21 62c99-14 231-8 378-27M38 86c128-11 237-5 342-22" stroke-width="10"/>' },
    { id: 'underline-loop', category: 'underlines', de: 'Underline – Loop', en: 'Underline – Loop', aspect: 3.9, viewBox: [0, 0, 390, 100], body: '<path d="M14 45c87 53 194 54 264 4 55-40-16-72-47-29-31 45 79 72 145 26" stroke-width="18"/>' },
    { id: 'underline-straight', category: 'underlines', de: 'Underline – Gerade', en: 'Underline – Straight', aspect: 4.6, viewBox: [0, 0, 460, 100], body: '<rect x="10" y="30" width="440" height="40" fill="white" stroke="none"/>' },
    { id: 'underline-straight-thin', category: 'underlines', de: 'Underline – Gerade fein', en: 'Underline – Straight thin', aspect: 4.8, viewBox: [0, 0, 480, 100], body: '<path d="M10 50h460" stroke-width="16" stroke-linecap="butt"/>' },
    { id: 'underline-hand-simple', category: 'underlines', de: 'Underline – Handlinie', en: 'Underline – Hand line', aspect: 4.5, viewBox: [0, 0, 450, 100], body: '<path d="M10 58c75-13 137 12 211-4 76-17 139 6 219-15" stroke-width="19"/>' },
    { id: 'underline-calligraphy', category: 'underlines', de: 'Underline – Kalligrafie', en: 'Underline – Calligraphy', aspect: 4.8, viewBox: [0, 0, 480, 100], body: '<path d="M8 70c101-42 233-58 375-43l89 18-91 20C241 91 114 94 8 82Z" fill="white" stroke="none"/>' },
    { id: 'underline-calligraphy-sweep', category: 'underlines', de: 'Underline – Pinselspitze', en: 'Underline – Brush taper', aspect: 5, viewBox: [0, 0, 500, 100], body: '<path d="M8 70c98-38 201-53 318-45 69 4 126 17 166 33-65-3-131 5-195 22-107 27-204 28-289 10Z" fill="white" stroke="none"/>' },
    { id: 'underline-calligraphy-long-fine', category: 'underlines', de: 'Underline – Kalligrafie lang & fein', en: 'Underline – Long fine calligraphy', aspect: 6.2, viewBox: [0, 0, 620, 100], body: '<path d="M8 65c137-28 290-42 448-35 63 3 116 11 156 22-78 2-153 10-226 24C233 101 106 93 8 77Z" fill="white" stroke="none"/>' },
    { id: 'underline-brush-long-fine', category: 'underlines', de: 'Underline – Pinselstrich lang & fein', en: 'Underline – Long fine brush stroke', aspect: 6.4, viewBox: [0, 0, 640, 100], body: '<path d="M8 52c111-24 232-34 364-29 96 4 181 15 260 33-89-1-171 4-247 17-139 23-265 25-377 6l23-9-23-8Z" fill="white" stroke="none"/>' }
  ];

  const categories = {
    arrows: { de: 'Pfeile', en: 'Arrows' },
    underlines: { de: 'Handgezeichnete Underlines', en: 'Hand-drawn underlines' },
    digital: { de: 'Smartphone & QR', en: 'Smartphone & QR' },
    payment: { de: 'Payment', en: 'Payment' },
    order: { de: 'Order & Pay', en: 'Order & Pay' },
    food: { de: 'Food & Drinks', en: 'Food & Drinks' },
    hospitality: { de: 'Hotellerie', en: 'Hospitality' },
    custom: { de: 'Eigene Piktogramme', en: 'Custom pictograms' }
  };

  const byId = new Map(icons.map(icon => [icon.id, { aspect: 1, ...icon }]));
  const customById = new Map();
  const assetSvgCache = new Map();

  function hashString(value) {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function parseViewBox(svg) {
    const values = String(svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    if (values.length === 4 && values.every(Number.isFinite) && values[2] > 0 && values[3] > 0) return values;
    const width = Number.parseFloat(svg.getAttribute('width'));
    const height = Number.parseFloat(svg.getAttribute('height'));
    return [0, 0, Number.isFinite(width) && width > 0 ? width : 100, Number.isFinite(height) && height > 0 ? height : 100];
  }

  function safePngDataUrl(value) {
    return /^data:image\/png;base64,[a-z0-9+/=\s]+$/i.test(String(value || ''));
  }

  function sanitizeSvg(source) {
    if (typeof source !== 'string' || !source.trim() || source.length > 800000) return null;
    const parsed = new DOMParser().parseFromString(source, 'image/svg+xml');
    const svg = parsed.documentElement;
    if (!svg || svg.localName !== 'svg' || parsed.querySelector('parsererror')) return null;
    parsed.querySelectorAll('script, foreignObject, iframe, object, embed, audio, video, canvas, style').forEach(node => node.remove());
    parsed.querySelectorAll('*').forEach(node => {
      Array.from(node.attributes || []).forEach(attribute => {
        const name = attribute.name.toLowerCase();
        const value = String(attribute.value || '');
        if (name.startsWith('on') || /(?:javascript:|data:text\/html|url\s*\()/i.test(value)) node.removeAttribute(attribute.name);
        if (
          (name === 'href' || name === 'xlink:href') &&
          value &&
          !value.startsWith('#') &&
          !safePngDataUrl(value)
        ) node.removeAttribute(attribute.name);
      });
    });
    const [minX, minY, width, height] = parseViewBox(svg);
    const rasterImage = Array.from(svg.querySelectorAll('image')).find(image =>
      safePngDataUrl(image.getAttribute('href') || image.getAttribute('xlink:href'))
    );
    const rasterDataUrl = rasterImage
      ? String(rasterImage.getAttribute('href') || rasterImage.getAttribute('xlink:href') || '')
      : '';
    const raster = svg.getAttribute('data-smoof-raster') === 'true' && Boolean(rasterDataUrl);
    const declaredRasterAspect = Number.parseFloat(svg.getAttribute('data-smoof-raster-aspect'));
    const aspect = raster && Number.isFinite(declaredRasterAspect) && declaredRasterAspect > 0
      ? Math.max(0.18, Math.min(8, declaredRasterAspect))
      : Math.max(0.18, Math.min(8, width / height));
    const children = Array.from(svg.childNodes).map(node => new XMLSerializer().serializeToString(node)).join('');
    const normalizedHeight = 100;
    const normalizedWidth = Math.max(18, Math.min(800, aspect * normalizedHeight));
    const scale = normalizedHeight / height;
    const transform = `translate(${-minX * scale} ${-minY * scale}) scale(${scale})`;
    return {
      source: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${normalizedWidth} ${normalizedHeight}"${raster ? ` data-smoof-raster="true" data-smoof-raster-aspect="${aspect}"` : ''}><g transform="${transform}">${children}</g></svg>`,
      aspect,
      raster,
      rasterDataUrl
    };
  }

  function registerCustom(source, name = '') {
    const normalized = sanitizeSvg(source);
    if (!normalized) return null;
    const id = `custom-${hashString(normalized.source)}`;
    const icon = {
      id,
      category: 'custom',
      de: name || 'Eigenes Piktogramm',
      en: name || 'Custom pictogram',
      custom: true,
      raster: normalized.raster === true,
      rasterDataUrl: normalized.rasterDataUrl || '',
      aspect: normalized.aspect,
      source: normalized.source
    };
    customById.set(id, icon);
    return { ...icon };
  }

  function registerRaster(dataUrl, name = '', width = 100, height = 100) {
    if (!safePngDataUrl(dataUrl) || String(dataUrl).length > 720000) return null;
    const safeWidth = Number.isFinite(Number(width)) && Number(width) > 0 ? Number(width) : 100;
    const safeHeight = Number.isFinite(Number(height)) && Number(height) > 0 ? Number(height) : 100;
    const aspect = Math.max(0.18, Math.min(8, safeWidth / safeHeight));
    const normalizedWidth = aspect * 100;
    const source = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${normalizedWidth} 100" data-smoof-raster="true" data-smoof-raster-aspect="${aspect}"><g><image href="${dataUrl}" x="0" y="0" width="${normalizedWidth}" height="100" preserveAspectRatio="xMidYMid meet"/></g></svg>`;
    const id = `custom-${hashString(source)}`;
    const icon = {
      id,
      category: 'custom',
      de: name || 'Eigenes PNG',
      en: name || 'Custom PNG',
      custom: true,
      raster: true,
      rasterDataUrl: dataUrl,
      aspect,
      source
    };
    customById.set(id, icon);
    return { ...icon };
  }

  function iconRecord(id) { return customById.get(id) || byId.get(id) || null; }

  function wrapBody(icon, side) {
    const viewBox = Array.isArray(icon.viewBox) && icon.viewBox.length === 4 && icon.viewBox.every(Number.isFinite)
      ? icon.viewBox
      : [0, 0, 100, 100];
    const [minX, minY, width, height] = viewBox;
    const transform = icon.sideAware && side === 'right'
      ? `translate(${(minX * 2) + width} 0) scale(-1 1)`
      : '';
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${minX} ${minY} ${width} ${height}"><g${transform ? ` transform="${transform}"` : ''} fill="none" stroke="white" stroke-width="7" stroke-linecap="round" stroke-linejoin="round">${icon.body}</g></svg>`;
  }

  function mirrorNormalized(source) {
    const parsed = new DOMParser().parseFromString(source, 'image/svg+xml');
    const svg = parsed.documentElement;
    const [minX, minY, width, height] = parseViewBox(svg);
    const inner = Array.from(svg.childNodes).map(node => new XMLSerializer().serializeToString(node)).join('');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${minX} ${minY} ${width} ${height}"><g transform="translate(${(minX * 2) + width} 0) scale(-1 1)">${inner}</g></svg>`;
  }

  function rasterMaskSvg(icon) {
    const maskId = `smoof-raster-mask-${String(icon.id || '').replace(/[^a-z0-9_-]/gi, '')}`;
    const width = Math.max(18, Math.min(800, Number(icon.aspect || 1) * 100));
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} 100"><g><defs><mask id="${maskId}" maskUnits="userSpaceOnUse" x="0" y="0" width="${width}" height="100" mask-type="alpha" style="mask-type:alpha"><image href="${icon.rasterDataUrl}" x="0" y="0" width="${width}" height="100" preserveAspectRatio="xMidYMid meet"/></mask></defs><rect x="0" y="0" width="${width}" height="100" fill="white" mask="url(#${maskId})"/></g></svg>`;
  }

  function iconSvg(id, side = 'left', options = {}) {
    const icon = iconRecord(id);
    if (!icon || icon.standard) return '';
    if (icon.raster) return options.colorize === true ? rasterMaskSvg(icon) : icon.source;
    let source = icon.source || assetSvgCache.get(id) || '';
    if (!source && icon.body) source = wrapBody(icon, side);
    if (source && icon.sideAware && side === 'right' && !icon.body) source = mirrorNormalized(source);
    return source;
  }

  async function loadSvg(id, side = 'left', options = {}) {
    const icon = iconRecord(id);
    if (!icon || icon.standard) return '';
    const existing = iconSvg(id, side, options);
    if (existing) return existing;
    if (!icon.asset) return '';
    try {
      const response = await fetch(assetUrl(icon.asset), { credentials: 'same-origin', cache: 'force-cache' });
      if (!response.ok) return '';
      const normalized = sanitizeSvg(await response.text());
      if (!normalized) return '';
      assetSvgCache.set(id, normalized.source);
      return iconSvg(id, side, options);
    } catch (error) { return ''; }
  }

  function dataUrl(id, side = 'left') {
    const icon = iconRecord(id);
    if (!icon) return '';
    if (icon.raster && icon.rasterDataUrl) return icon.rasterDataUrl;
    if (icon.standard) {
      const circles = [22, 42, 62, 82, 102, 122].map((x, index) => `<circle cx="${x}" cy="50" r="${3 + index * 0.75}"/>`).join('');
      const arrow = `<path d="m126 24 28 26-28 26" fill="none" stroke="black" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>`;
      const content = side === 'right'
        ? `<g transform="translate(176 0) scale(-1 1)">${circles}${arrow}</g>`
        : `${circles}${arrow}`;
      const preview = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 176 100" fill="black">${content}</svg>`;
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(preview)}`;
    }
    const source = iconSvg(id, side);
    if (source) return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(source)}`;
    return icon.asset ? assetUrl(icon.asset) : '';
  }

  icons.filter(icon => icon.asset).forEach(icon => loadSvg(icon.id));

  window.SmoofPictogramLibrary = Object.freeze({
    icons: Object.freeze(icons.map(icon => Object.freeze({ aspect: 1, ...icon }))),
    categories: Object.freeze(categories),
    has(id) { return Boolean(iconRecord(id)); },
    get(id) { const icon = iconRecord(id); return icon ? { ...icon } : null; },
    svg: iconSvg,
    loadSvg,
    dataUrl,
    sanitizeSvg,
    registerCustom,
    registerRaster
  });
})();
